import axios from 'axios';
import { getApiUrl } from '@/config/api';

const BASE = '/api/CatEmpresa/erp-externo';

export default {
  async leer(empresaId) {
    const r = await axios.post(getApiUrl(`${BASE}/lectura`), { EmpresaId: empresaId });
    return r.data;
  },

  async guardar(model) {
    const r = await axios.post(getApiUrl(`${BASE}/guardar`), model);
    return r.data;
  },

  async borrar(empresaId) {
    const r = await axios.post(getApiUrl(`${BASE}/borrar`), { EmpresaId: empresaId });
    return r.data;
  },

  async probarConexion(empresaId) {
    const r = await axios.post(getApiUrl(`${BASE}/probar-conexion`), { EmpresaId: empresaId });
    return r.data;
  }
};
